import React from "react";
import { Link } from "react-router-dom";

export default function FounderBlock() {
  return (
    <section className="bg-r24-black text-white" data-testid="founder-block">
      <div className="max-w-7xl mx-auto px-4 py-12 md:py-16 grid md:grid-cols-[320px_1fr] gap-8 md:gap-12 items-center">
        <div className="relative mx-auto md:mx-0 w-[240px] md:w-full max-w-[300px]">
          <div className="absolute -inset-2 border-2 border-r24-red" />
          <img src="/brand/founder.jpg" alt="Shivam Dubey — Editor-in-Chief & Founder"
            className="relative w-full object-cover grayscale-[15%]" data-testid="founder-photo" />
        </div>
        <div>
          <span className="kicker text-xs">Editorial Leadership</span>
          <h2 className="font-head font-bold text-4xl md:text-5xl mt-2">Shivam Dubey</h2>
          <div className="mt-2 flex flex-wrap gap-2">
            <span className="bg-r24-red text-white text-xs font-bold uc px-3 py-1">Editor-in-Chief</span>
            <span className="border border-white/40 text-white text-xs font-bold uc px-3 py-1">Founder</span>
          </div>
          <p className="text-gray-300 mt-5 leading-relaxed max-w-2xl">
            Shivam Dubey leads the Rapid24News newsroom with a commitment to fast, trusted and fearless journalism.
            Under his editorial direction, Rapid24News delivers priority coverage of Lucknow and Uttar Pradesh,
            alongside credible national and international news — always distinguishing verified facts from allegations.
          </p>
          <p className="font-head text-xl mt-5 text-white/90">
            Rapid<span className="text-r24-red">24</span>News — <span className="uc tracking-wide">Fast • Trusted • Fearless</span>
          </p>
          <Link to="/about" className="inline-block mt-5 border border-white/50 hover:bg-r24-red hover:border-r24-red text-white font-bold uc text-sm px-6 py-3 transition-colors" data-testid="founder-about-link">
            About Rapid24News →
          </Link>
        </div>
      </div>
    </section>
  );
}
